var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoUniqornio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 390 1828 482.2",
    enableBackground: "new 0 390 1828 482.2",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BFBFBF",
    d: "M1550.5,406.2l-22.2,150l37.7-71.7l-7.6-78.1C1557.9,401.7,1551.2,401.6,1550.5,406.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#BFBFBF",
    points: "1528.1,568.4 1565.9,496.6 1581.8,623.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#BFBFBF",
    points: "1583.3,633.8 1510.9,703 1528,575.9  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFBFBF",
    d: "M1499.4,791.3c-7.3,43.7,31.2,69.3,54.5,67.9c12.4,0.2,31.6-6.1,42.4-27.5l-86.8-113.2L1499.4,791.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFBFBF",
    d: "M1606.7,787.4l-23-146l-72.8,68.5l88.2,115.8C1608.5,813.9,1607.6,797.1,1606.7,787.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BFBFBF",
    stroke: "#C0BEBE",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    d: "M15,698.8V538.9c0-1.2,0.5-2.2,1.4-3 c0.9-0.8,1.9-1.2,2.9-1.2h14.6c2.8,0,4.3,1.4,4.3,4.3v159.9c0,5.9,2.1,10.9,6.2,15c4.2,4.2,9.2,6.2,15,6.2h67.8 c5.9,0,10.9-2.1,15-6.2c4.2-4.2,6.2-9.2,6.2-15V538.9c0-2.8,1.4-4.3,4.3-4.3h14.6c2.8,0,4.3,1.4,4.3,4.3v159.9 c0,6.1-1.2,11.9-3.5,17.3c-2.3,5.5-5.5,10.2-9.6,14.1c-4.1,4-8.8,7.1-14.1,9.4c-5.4,2.3-11.1,3.5-17.2,3.5H59.3 c-6.1,0-11.8-1.2-17.2-3.5c-5.4-2.3-10.1-5.5-14.1-9.4c-4.1-4-7.2-8.7-9.6-14.1C16.1,710.7,15,704.9,15,698.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFBFBF",
    stroke: "#C0BEBE",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    d: "M360.3,739v-87.3L250,560.5V739 c0,2.8-1.4,4.3-4.3,4.3h-14.6c-1,0-2-0.4-2.9-1.2c-0.9-0.8-1.4-1.8-1.4-3v-200c0-1.2,0.5-2.2,1.4-3c0.9-0.8,1.9-1.2,2.9-1.2h20.4 c2.8,0,5.4,0.9,7.6,2.7L360.3,621v-82.1c0-2.8,1.4-4.3,4.3-4.3h14.6c2.8,0,4.3,1.4,4.3,4.3v200c0,2.8-1.4,4.3-4.3,4.3h-14.6 C361.7,743.2,360.3,741.8,360.3,739z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFBFBF",
    stroke: "#C0BEBE",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    d: "M443,739v-14.6c0-1,0.4-2,1.2-2.9 c0.8-0.9,1.8-1.4,3-1.4h58.4V557.8h-58.4c-2.8,0-4.3-1.4-4.3-4.3v-14.6c0-2.8,1.4-4.3,4.3-4.3h139.5c2.8,0,4.3,1.4,4.3,4.3v14.6 c0,2.8-1.4,4.3-4.3,4.3h-58.1v162.3h58.1c1.2,0,2.2,0.5,3,1.4c0.8,0.9,1.2,1.9,1.2,2.9V739c0,2.8-1.4,4.3-4.3,4.3H447.3 C444.4,743.2,443,741.8,443,739z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFBFBF",
    stroke: "#C0BEBE",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    d: "M717.5,768.2v-24.9H695 c-6.1,0-11.8-1.2-17.2-3.5c-5.4-2.3-10.1-5.5-14.1-9.4c-4.1-4-7.2-8.7-9.6-14.1c-2.3-5.5-3.5-11.2-3.5-17.3l0.3-119.8 c0-6.1,1.2-11.8,3.5-17.2c2.3-5.4,5.5-10.1,9.4-14.1c4-4.1,8.7-7.2,14.1-9.6c5.5-2.3,11.2-3.5,17.3-3.5h67.5 c6.1,0,11.9,1.2,17.3,3.5c5.5,2.3,10.2,5.5,14.1,9.6c4,4.1,7.1,8.8,9.4,14.1c2.3,5.4,3.5,11.1,3.5,17.2v119.8 c0,6.1-1.2,11.9-3.5,17.3c-2.3,5.5-5.5,10.2-9.6,14.1c-4.1,4-8.8,7.1-14.1,9.4c-5.4,2.3-11.1,3.5-17.2,3.5h-22.5v24.9 c0,1-0.4,2-1.2,2.9c-0.8,0.9-1.8,1.4-3,1.4h-14.3c-1.2,0-2.2-0.5-3-1.4C718,770.1,717.5,769.2,717.5,768.2z M695.4,557.8 c-5.9,0-10.9,2.1-15.2,6.2c-4.3,4.2-6.4,9.2-6.4,15v119.8c0,5.9,2.1,10.9,6.2,15c4.2,4.2,9.2,6.2,15,6.2h67.8 c5.9,0,10.9-2.1,15-6.2c4.2-4.2,6.2-9.2,6.2-15V579.1c0-5.9-2.1-10.9-6.2-15c-4.2-4.2-9.2-6.2-15-6.2H695.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFBFBF",
    stroke: "#C0BEBE",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    d: "M906.6,743.2c-6.1,0-11.8-1.2-17.2-3.5 c-5.4-2.3-10-5.5-14-9.4c-4-4-7.1-8.7-9.4-14.1c-2.3-5.5-3.5-11.2-3.5-17.3V579.1c0-6.1,1.2-11.8,3.5-17.2 c2.3-5.4,5.5-10.1,9.4-14.1c4-4.1,8.6-7.2,14-9.6c5.4-2.3,11.1-3.5,17.2-3.5h67.8c6.1,0,11.8,1.2,17.2,3.5 c5.4,2.3,10.1,5.5,14.1,9.6c4.1,4.1,7.2,8.8,9.6,14.1c2.3,5.4,3.5,11.1,3.5,17.2v119.8c0,6.1-1.2,11.9-3.5,17.3 c-2.3,5.5-5.5,10.2-9.6,14.1c-4.1,4-8.8,7.1-14.1,9.4c-5.4,2.3-11.1,3.5-17.2,3.5H906.6z M906.6,557.8c-5.9,0-10.9,2.1-15,6.2 c-4.2,4.2-6.2,9.2-6.2,15v119.8c0,5.9,2.1,10.9,6.2,15c4.2,4.2,9.2,6.2,15,6.2h67.8c5.9,0,10.9-2.1,15-6.2c4.2-4.2,6.2-9.2,6.2-15 V579.1c0-5.9-2.1-10.9-6.2-15c-4.2-4.2-9.2-6.2-15-6.2H906.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFBFBF",
    stroke: "#C0BEBE",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    d: "M1201.9,739.3l-39.5-88.8h-65.1V739 c0,2.8-1.4,4.3-4.3,4.3h-14.3c-2.8,0-4.3-1.4-4.3-4.3v-200c0-2.8,1.4-4.3,4.3-4.3h107.6c6.1,0,11.8,1.2,17.2,3.5 c5.4,2.3,10.1,5.5,14.1,9.6c4.1,4.1,7.2,8.8,9.6,14.1c2.3,5.4,3.5,11.1,3.5,17.2v27.1c0,9.9-3,18.8-9,26.6 c-6,7.8-13.7,13.1-23.3,16l-10.3,3l38.9,87.6c0.6,1,0.7,1.9,0.2,2.7c-0.5,0.8-1.4,1.2-2.6,1.2h-16.7c-1.2,0-2.4-0.4-3.6-1.2 C1203.1,741.2,1202.3,740.3,1201.9,739.3z M1097.3,627.4h89.1c5.9,0,10.9-2.1,15-6.2c4.2-4.2,6.2-9.2,6.2-15v-27.1 c0-5.9-2.1-10.9-6.2-15c-4.2-4.2-9.2-6.2-15-6.2h-89.1V627.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFBFBF",
    stroke: "#C0BEBE",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    d: "M1419.5,739v-87.3l-110.4-91.2V739 c0,2.8-1.4,4.3-4.3,4.3h-14.6c-1,0-2-0.4-2.9-1.2c-0.9-0.8-1.4-1.8-1.4-3v-200c0-1.2,0.5-2.2,1.4-3c0.9-0.8,1.9-1.2,2.9-1.2h20.4 c2.8,0,5.4,0.9,7.6,2.7l101.2,83.6v-82.1c0-2.8,1.4-4.3,4.3-4.3h14.6c2.8,0,4.3,1.4,4.3,4.3v200c0,2.8-1.4,4.3-4.3,4.3h-14.6 C1420.9,743.2,1419.5,741.8,1419.5,739z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFBFBF",
    stroke: "#C0BEBE",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    d: "M1702.8,743.2c-6.1,0-11.8-1.2-17.2-3.5 c-5.4-2.3-10-5.5-14-9.4c-4-4-7.1-8.7-9.4-14.1c-2.3-5.5-3.5-11.2-3.5-17.3V579.1c0-6.1,1.2-11.8,3.5-17.2 c2.3-5.4,5.5-10.1,9.4-14.1c4-4.1,8.6-7.2,14-9.6c5.4-2.3,11.1-3.5,17.2-3.5h67.8c6.1,0,11.8,1.2,17.2,3.5 c5.4,2.3,10.1,5.5,14.1,9.6c4.1,4.1,7.2,8.8,9.6,14.1c2.3,5.4,3.5,11.1,3.5,17.2v119.8c0,6.1-1.2,11.9-3.5,17.3 c-2.3,5.5-5.5,10.2-9.6,14.1c-4.1,4-8.8,7.1-14.1,9.4c-5.4,2.3-11.1,3.5-17.2,3.5H1702.8z M1702.8,557.8c-5.9,0-10.9,2.1-15,6.2 c-4.2,4.2-6.2,9.2-6.2,15v119.8c0,5.9,2.1,10.9,6.2,15c4.2,4.2,9.2,6.2,15,6.2h67.8c5.9,0,10.9-2.1,15-6.2c4.2-4.2,6.2-9.2,6.2-15 V579.1c0-5.9-2.1-10.9-6.2-15c-4.2-4.2-9.2-6.2-15-6.2H1702.8z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#BFBFBF",
    d: "M735.6,723.9h-13.5c-5.1,0-9.2-4.1-9.2-9.2v-11.3c0-5.1,4.1-9.2,9.2-9.2h13.5c5.1,0,9.2,4.1,9.2,9.2v11.3 C744.8,719.8,740.7,723.9,735.6,723.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoUniqornio);
export default __webpack_public_path__ + "static/media/Logo_Uniqornio.25243ff10243696283b62b5e29dc3723.svg";
export { ForwardRef as ReactComponent };